import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { locale, client } from "../config/appwrite";

@Injectable({
  providedIn: "root",
})
export class ApisService {
  constructor(public httpClient: HttpClient) {}

  // Método para acceder a la funcionalidad Realtime
  subscribe(channels: string[], callback: (response: any) => void) {
    return client.subscribe(channels, callback);
  }

  public getAllCountries_new() {
    const promise = locale.listCountries();
    return promise;
  }

  // ###############################################################################################################
  // API obtener disponibilidad de hora para tomar una cita.
  // Aquí en esta api ya valida la agenda del especialista y le resta las citas y devuelve un objeto con fechas y horas
  // API: {{url}}/getTimeEspecialista
  /**
   * 
   * @returns {
    "status": "success",
    "message": [
        {
            "fecha": "2024-10-16",
            "horas_disponibles": [
                {
                    "hora": "10:00",
                    "consultorio": "Country / online"
                },...
            ]
        },
        {
            "fecha": "2024-10-17",
            "horas_disponibles": [
                {
                    "hora": "10:30",
                    "consultorio": "Country / online"
                },....
   */

  public getTimeEspecialista(
    idEspecialista: string,
    fechaStart: string,
    fechaEnd: string
  ) {
    const body = {
      idEspecialista: idEspecialista,
      fechaStart: fechaStart,
      fechaEnd: fechaEnd,
    };

    // TODO: temporal la url de la api local
    return this.httpClient.post(
      environment.apiStates + "/getTimeEspecialista",
      body
    );
    // return this.httpClient.post("http://192.168.1.8:8000/getTimeEspecialista", body);
  }

  // ###############################################################################################################
  // VERSION NUEVA PAISES
  public getCountries() {
    return this.httpClient.get(environment.apiStates + "/countries");
  }

  public getStatesCountries(cod: string) {
    return this.httpClient.get(environment.apiStates + "/states/" + cod);
  }
  public getCitiesCountries(cod: string) {
    return this.httpClient.get(environment.apiStates + "/cities/" + cod);
  }
  // Obtener solo una ciudad por el id, el cual fue guardado en la collection
  public getCity(idCity: string) {
    return this.httpClient.get(environment.apiStates + "/city/" + idCity);
  }
}
